import React, { Component } from 'react';

export default class SelectionListItem extends Component {
    render() {
        if (this.props.selected) {
            return React.Children.map(this.props.children, child => {
                return React.cloneElement(child, {
                    className: (child.props.className || '') + ' selected',
                    selected: true
                });
            });
        }
        return this.props.children;
    }
}
